<template>
  <div>
    <!--タイトル-->
    <header id="header">

      <Header title-image="static/images/common/logo-word.svg" can-back-flag="1"></Header>

      <div class="word-search-box">
        <div class="word-search-form-box">
          <div>
            <input id="keyword" type="text" class="search-form-input" placeholder="検索語句を入力してください" v-model='keyword' v-on:keyup='searchAction'/>
          </div>
        </div>

        <div class="tab-nav-box" v-show="isHistory">
          <ul class="tab-nav">
            <li class="select" v-on:click='tabAction' data-sort="id"><span>50音で検索</span></li>
            <li v-on:click='tabAction' data-sort="part_order"><span>章で検索</span></li>
          </ul>
        </div>
        <section class="tab-contents-box shoplist-index">
          <div id="tab-content-nav1" class="tab-contents-nav">
            <div class="word-search-nav-box">
              <div class="box-l">
                <ul class="box head-box">
                  <li><button class="btn btn-word" v-on:click='columnAction' val="あ" :disabled="!hasCol1"><img :src="hasCol1 ? 'static/images/word/kana-a.svg': 'static/images/word/kana-a-disable.svg'" alt="あ"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="か" :disabled="!hasCol2"><img :src="hasCol2 ? 'static/images/word/kana-ka.svg': 'static/images/word/kana-ka-disable.svg'" alt="か"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="さ" :disabled="!hasCol3"><img :src="hasCol3 ? 'static/images/word/kana-sa.svg': 'static/images/word/kana-sa-disable.svg'" alt="さ"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="た" :disabled="!hasCol4"><img :src="hasCol4 ? 'static/images/word/kana-ta.svg': 'static/images/word/kana-ta-disable.svg'" alt="た"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="な" :disabled="!hasCol5"><img :src="hasCol5 ? 'static/images/word/kana-na.svg': 'static/images/word/kana-na-disable.svg'" alt="な"></button></li>
                </ul>
                <ul class="box">
                  <li><button class="btn btn-word" v-on:click='columnAction' val="は" :disabled="!hasCol6"><img :src="hasCol6 ? 'static/images/word/kana-ha.svg': 'static/images/word/kana-ha-disable.svg'" alt="は"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="ま" :disabled="!hasCol7"><img :src="hasCol7 ? 'static/images/word/kana-ma.svg': 'static/images/word/kana-ma-disable.svg'" alt="ま"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="や" :disabled="!hasCol8"><img :src="hasCol8 ? 'static/images/word/kana-ya.svg': 'static/images/word/kana-ya-disable.svg'" alt="や"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="ら" :disabled="!hasCol9"><img :src="hasCol9 ? 'static/images/word/kana-ra.svg': 'static/images/word/kana-ra-disable.svg'" alt="ら"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="わ" :disabled="!hasCol10"><img :src="hasCol10 ? 'static/images/word/kana-wa.svg': 'static/images/word/kana-wa-disable.svg'" alt="わ"></button></li>
                  <li><button class="btn btn-word" v-on:click='columnAction' val="A" :disabled="!hasCol11"><img :src="hasCol11 ? 'static/images/word/alphabet-a.svg': 'static/images/word/alphabet-a-disable.svg'" alt="A"></button></li>
                </ul>
              </div>
              <div class="box-r">
                <button class="btn btn-word" v-on:click='columnAction' val=""><img src="static/images/word/all.svg" alt="全表示"></button>
              </div>
            </div>
          </div>
          <div id="tab-content-nav2" class="tab-contents-nav" style="display: none;">
            <div class="word-search-nav-box chapter-box">
              <div class="box-l">
                <select v-model='selectedPart' v-on:change='selectPart'>
                  <option value="" disabled>選択してください</option>
                  <option v-for='part in partArray' :value="part" v-html="part"></option>
                </select>
              </div>
              <div class="box-r">
                <button class="btn btn-word" v-on:click='resetPart' val=""><img src="static/images/word/all.svg" alt="全表示"></button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </header>

    <div id="wrapper">
	    <div class="content">
        <div>
        </div>
        <div id="tab-content1" class="tab-contents">
          <div class="word-list" v-for='row in sort_rows' v-bind:key='row.id'>
            <div class="box-l">
              <div v-show="showColumn && row.header != 'A'" v-html="row.header" style="white-space: pre;"></div>
              <div v-show="showColumn && row.header == 'A'">Ａ</div>
            </div>
            <div class="box-r">
              <ul>
                <li><a href='#' :keyword='row.value' v-on:click.prevent='linkAction' v-html="row.filter_value"></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div id="tab-content2" class="tab-contents" style="display: none;" v-show="isHistory">
          <div class="word-list chapter-box" v-for='part in partArray' v-if="selectedPart == '' || selectedPart == part">
            <div class="box-l">
              <span v-show="showColumn" v-html="part"></span>
            </div>
            <div class="box-r">
              <ul>
                <li v-for='row in sort_rows' v-if="row.part == part"><a href="#" :keyword='row.value' v-on:click.prevent='linkAction' v-html="row.filter_value"></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  data: function () {
    return {
      showColumn: true,
      selectedPart: '',
      partArray: [
        '1部1章',
        '2部序章',
        '2部1章',
        '2部2章',
        '2部3章',
        '3部1章',
        '3部2章',
        '3部3章',
        '4部1章',
        '4部2章',
        '4部3章',
        '4部4章',
        '4部5章',
        '4部6章',
        '5部1章',
        '5部2章',
        '5部3章',
      ],
      sort_key: "",
    }
  },
  mounted: function () {

    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-word")
    $("body").addClass("page-word-index")
    cmd.adjustStyle()

    this.loadData()
    this.resetPart()

    window.onload = () => {
      this.wrapperMaginInit();
    };
  },
  methods: {
    ...mapActions('WordModule', {
      'prevAction': 'prevAction',
      'loadData': 'loadData',
      'search': 'search',
      'searchColumn': 'searchColumn',
      'searchPart': 'searchPart',
      'showDetail': 'showDetail',
    }),
    searchAction (e) {
      var val = $("#keyword").val()
      if (val == "") {
        this.showColumn = true
      } else {
        this.showColumn = false
      }
      this.search(val)
    },
    columnAction (e) {
      this.showColumn = true
      var element = e.currentTarget
      var value = $(element).attr("val")
      this.searchColumn(value)
    },
    selectPart (e) {
      this.showColumn = true
      this.searchPart(this.selectedPart)
    },
    resetPart (e) {
      this.showColumn = true
      this.selectedPart = ''
      this.searchColumn('')
    },
    linkAction (e) {
      var element = e.currentTarget
      var keyword = element.getAttribute('keyword')
      this.showDetail(keyword)
    },
    tabAction (e) {
      var element = e.currentTarget
      var sort = $(element).attr('data-sort');
      var index = $('.tab-nav li').index(element);
      $('.tab-contents-nav').css('display','none');
      $('.tab-contents-nav').eq(index).css('display','block');
      $('.tab-contents').css('display','none');
      $('.tab-contents').eq(index).css('display','block');
      $('.tab-nav li').removeClass('select');
      $(element).addClass('select');
      this.wrapperMaginInit();
      this.resetPart()
      this.sortBy(sort)
    },
    wrapperMaginInit() {
      var winHeight = $(window).height();
      var eleHeader = $("#header");
      var eleFooter = $("#footer");
      var eleWrapper = $("#wrapper");

      var eleHeaderHeight = $(eleHeader).height();
      var eleFooterHeight = $(eleFooter).height();

      var wrapperMaginTop = eleHeaderHeight + 10;
      var wrapperMaginBottom = eleFooterHeight + 40;

      $(eleWrapper).css('margin-top',wrapperMaginTop);
      $(eleWrapper).css('margin-bottom',wrapperMaginBottom);
    },
    sortBy(key) {
      this.sort_key = key;
    },
  },
  computed: {

    keyword: {
      get () {
        return this.model.keyword
      },
      set (value) {
        this.model.keyword = value
      }
    },
    ...mapGetters('WordModule', [
      'model',
      'rows',
      'hasCol1',
      'hasCol2',
      'hasCol3',
      'hasCol4',
      'hasCol5',
      'hasCol6',
      'hasCol7',
      'hasCol8',
      'hasCol9',
      'hasCol10',
      'hasCol11'
    ]),
    ...mapGetters('MenuModule', [
      'isGeo',
      'isHistory',
      'isCivics',
    ]),

    sort_rows() {
      if (this.sort_key != "") {
        this.rows.sort((a, b) => {
          if (parseInt(a[this.sort_key]) < parseInt(b[this.sort_key])) return -1;
          if (parseInt(a[this.sort_key]) > parseInt(b[this.sort_key])) return 1;
          return 0;
        });
        return this.rows;
      } else {
        return this.rows;
      }
    },
  },
  components: {
    Header
  }
}
</script>

<style scoped>
input[type=text] {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/WordList.vue